import { Checkbox, Popover } from "antd";
import axios from "axios";
import React from "react";
import { Settings } from "react-feather";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import actions from "../../../../redux/settings/actions";
import "./column-config.css";

const mapModeToTable = (mode) => {
  switch (mode) {
    case "budget":
      return "budget_table";
    case "powo":
      return "powo_table";
    case "bidding":
      return "bidding_table";
    case "vendor":
      return "vendor_table";
    case "approval":
      return "approval_table";
    case "rate_contract":
      return "rate_contract_table";
    default:
      return "";
  }
};

const ColumnConfig = ({ columns: cols, setCols, mode, ...props }) => {
  const { dispatch, settings } = props;

  React.useEffect(() => {
    if (!settings?.user?.user_selected_columns?.[mapModeToTable(mode)]) {
      return;
    }

    // const userSelectedColumns = settings?.user?.user_selected_columns?.[mapModeToTable(mode)];
    // setCols(cols.filter(col => {
    //   const found = userSelectedColumns.find(userCol => userCol.key === col.key);
    //   if (!found) return true;

    //   return found.selected !== false;
    // }));
  }, [cols, mode, setCols, settings?.user?.user_selected_columns]);

  const content = (
    <>
      {cols.map((col) => (
        <div className="col-checkbox-container" key={col.key}>
          <Checkbox
            checked={
              cols.find((column) => column.key === col.key).selected !== false
            }
            onChange={(ev) => {
              const newCols = cols.map((column) => {
                if (column.key === col.key) {
                  column.selected = ev.target.checked;
                }
                return column;
              });
              setCols(newCols);
              let user_selected_columns = {};
              if (!props.settings?.user?.user_selected_columns) {
                user_selected_columns = {
                  ...props.settings?.user?.user_selected_columns,
                };
              }
              user_selected_columns[mapModeToTable(mode)] = newCols;
              dispatch({
                type: actions.CHANGE_SETTING,
                payload: {
                  setting: "user",
                  value: {
                    ...props.settings?.user,
                    user_selected_columns: {
                      ...user_selected_columns,
                    },
                  },
                },
              });

              const values = new FormData();
              values.append(
                "user_selected_columns",
                JSON.stringify(user_selected_columns)
              );
              const config = {
                headers: {
                  "content-type": "multipart/form-data",
                },
              };
              axios
                .put(`apiV1/user/${props.settings?.user?.id}/`, values, config)
                .then((res) => {})
                .catch((error) => {
                  toast.error("Something went wrong. Please try again later.", {
                    toastId: "column-config",
                  });
                });
              console.log("i-log> dispatch");
            }}
          >
            {col.title}
          </Checkbox>
        </div>
      ))}
    </>
  );

  return (
    <Popover content={content} placement="bottomLeft" trigger="click">
      <Settings />
    </Popover>
  );
};

const mapStateToProps = ({ dispatch, settings }) => ({
  dispatch,
  settings,
});

export default connect(mapStateToProps)(ColumnConfig);
